import { ENavigationPath } from 'constants/path';
import { Spin } from 'antd';
import { Navigate, Outlet } from 'react-router';
import { useAuth } from 'hooks/useAuth';

export const PrivateRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <Spin className="flex justify-center items-center h-screen" />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to={ENavigationPath.LOGIN} />;
};
